import { landingContent } from './data/landingContent'
import { AboutSection } from './components/AboutSection'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { ProcessSection } from './components/ProcessSection'
import { ProductSection } from './components/ProductSection'
import { ProofStrip } from './components/ProofStrip'
import { PurchaseScaleSection } from './components/PurchaseScaleSection'
import { VolumeSection } from './components/VolumeSection'
import { LeadRequestSection } from '../lead-request/components/LeadRequestSection'
import './landing.css'

export function LandingPage() {
  const content = landingContent

  return (
    <>
      <Header navigation={content.navigation} />
      <main id="contenido">
        <Hero hero={content.hero} />
        <ProofStrip items={content.proofPoints} />
        <AboutSection />
        <ProductSection items={content.productCategories} />
        <PurchaseScaleSection content={content.purchaseScale} />
        <VolumeSection content={content.volumeOffer} />
        <ProcessSection items={content.process} />
        <LeadRequestSection />
      </main>
      <Footer />
    </>
  )
}
